import api, { formatApiError } from "@/lib/api";

const MARK = /\[\[[A-Z_]+(:[^\]]*)?\]\]/g;

export async function streamAssistant(body, onEvent) {
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/assistant/chat`;
  const send = () => fetch(url, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
  let res = await send();
  if (res.status === 401) {
    await api.post("/auth/refresh").catch(() => {});
    res = await send();
  }
  if (!res.ok) {
    let detail;
    try { detail = (await res.json()).detail; } catch {}
    throw new Error(formatApiError(detail));
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    let i;
    while ((i = buf.indexOf("\n\n")) >= 0) {
      const line = buf.slice(0, i).split("\n").find((l) => l.startsWith("data: "));
      buf = buf.slice(i + 2);
      if (line) onEvent(JSON.parse(line.slice(6)));
    }
  }
}

export function cleanText(text) {
  return text.replace(MARK, "").replace(/\[\[[^\]]*$/, "").trim();
}

export function pickHighlights(text, allowed) {
  const ids = [...text.matchAll(/\[\[DESTACAR:([A-Za-z0-9_-]+)\]\]/g)].map((m) => m[1]);
  return (allowed || []).filter((h) => ids.includes(h.testid));
}

export function highlightElement(testid) {
  const el = [...document.querySelectorAll(`[data-testid="${CSS.escape(testid)}"]`)].find((e) => e.getClientRects().length > 0);
  if (!el) return false;
  el.scrollIntoView({ behavior: "smooth", block: "center" });
  el.classList.add("acompanha-ia-highlight");
  setTimeout(() => el.classList.remove("acompanha-ia-highlight"), 4500);
  return true;
}
